const particlesScriptTag: HTMLScriptElement = document.createElement("script");

if (typeof window !== "undefined") {
}

export { particlesScriptTag };
